module.exports = __webpack_public_path__ + "media/images/common/footer_bg-0c3f965d224befd8bb5fa9d59d2ffb7c.gif";